module.exports = __webpack_public_path__ + "media/assets/images/icons/reactive-af2ac7a43f80b1a90b87627ee64046fd.png";